<template>
    <div class="container mt-3 narrow-container">
        <b-card class="mb-2">
            <h2>{{ $t('reset.title') }}</h2>
        </b-card>

        <form @submit.stop.prevent="resetUser" ref="resetUserForm">
          <b-card v-if="tokenValid" :header="$t('userAdministration.changePassword')" class="mb-3">
            <b-form-fieldset :label="$t('userAdministration.userLogin')">
                <label class="activation-info-label">{{user.login}}</label>
            </b-form-fieldset>

            <b-form-fieldset :label="$t('userAdministration.newPassword')">
                <b-form-input type="password" v-model="user.password"></b-form-input>
            </b-form-fieldset>

            <b-form-fieldset :label="$t('userAdministration.confirmPassword')">
                <b-form-input type="password" v-model="user.newPassword"></b-form-input>
            </b-form-fieldset>

            <b-row class="m-0 p-0"><b-col><small>* {{$t('userAdministration.userPasswordRequirement.0')}}</small></b-col></b-row>
            <b-row class="m-0 p-0"><b-col><small>* {{$t('userAdministration.userPasswordRequirement.1')}}</small></b-col></b-row>
            <b-row class="m-0 p-0"><b-col><small>* {{$t('userAdministration.userPasswordRequirement.2')}}</small></b-col></b-row>
            <b-row class="m-0 p-0"><b-col><small>* {{$t('userAdministration.userPasswordRequirement.3')}}</small></b-col></b-row>
            
            <div slot="footer" class="text-right">
                <b-button type="submit" variant="success" :disabled="!user.password || !user.newPassword || load">
                  {{ $t('userAdministration.apply') }}
                  <loader :show="load" type="button"></loader>
                </b-button>
            </div>
        </b-card>
      </form>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import Loader from '@/components/misc/Loader'

  export default {
    name: 'activation',
    components: {
      Loader
    },
    data () {
      return {
        load: false,
        token: '',
        user: {},
        tokenValid: false
      }
    },
    created () {
      this.logConsole('Reset request received')
      this.token = this.$route.query.token
      let activationToken = {activationToken: this.token}

      this.$http.post(Vue.$apiConfig.validateResetTokenPost, activationToken)
        .then(response => {
          this.logConsole(response)
          this.tokenValid = true
          this.user = response.body.payload
        }, error => {
          this.logConsole(error)
          this.tokenValid = false
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$translate('apiStatusCodes.' + error.data.status.code),
            errors: []
          })
        })
    },
    methods: {
      resetUser () {
        this.logConsole('Resetting user')
        if (this.user.password === this.user.newPassword) {
          this.load = true
          this.$http.post(Vue.$apiConfig.resetUserPost + '?token=' + this.token, this.user)
            .then(response => {
              this.logConsole(response)
              this.load = false
              EventBus.$emit('alert', {
                variant: 'success',
                message: this.$translate('reset.success'),
                errors: []
              })
              this.$refs.resetUserForm.reset()
              this.user.password = this.user.newPassword = null
            }, error => {
              this.logConsole(error)
              this.formatErrorResponse(error)
              this.load = false
            })
        } else {
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('userAdministration.confirmPasswordFail'),
            errors: []
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .narrow-container {
    width: 800px;
  }

  .activation-info-label {
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// Reset.vue?7eafc868